import { AppContent } from '../AppContent';

const alreadyRegistered: AppContent['alreadyRegistered'] = {
  alreadyRegisteredContent: [
    {
      serviceName: 'Business Internet Banking',
      header: 'You’ve already registered',
      notificationHeader: 'Log in using the details you’ve already set up',
      forgottenDetails: 'Forgotten your login details?',
      youCan: 'You can',
      resetThemOnline: 'reset them online.',
      resetThemOnlineHref:
        'https://online-business.bankofscotland.co.uk/ib-access/cwa/forgotten-details/index.html#/your-details?_k=0461kp',
      btnLabel: 'Log in',
      btnHref:
        'https://online-business.bankofscotland.co.uk/business/logon/login.jsp',
    },
  ],
};

export default alreadyRegistered;
